// platform/app/src/hooks/useClientContacts.ts
import { useQuery } from '@tanstack/react-query'
import { supabase } from '@loop3/supabase-client'
import type { ClientContact } from '@/lib/types'

export function useClientContacts(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client-contacts', clientId],
    queryFn: async (): Promise<ClientContact[]> => {
      const { data, error } = await supabase
        .from('client_contacts')
        .select(
          'id, client_id, name, role, email, linkedin_url, is_primary, sort_order'
        )
        .eq('client_id', clientId!)
        .order('is_primary', { ascending: false })
        .order('sort_order', { ascending: true })
      if (error) throw error
      return (data ?? []) as ClientContact[]
    },
    enabled: !!clientId,
    staleTime: 60_000,
  })
}
